(function(){
  'use strict';

  function slugify(value){
    return value.toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,72) || 'section';
  }

  function uniqueId(base,used){
    var candidate='legal-'+base;
    var index=2;
    while(used[candidate]||document.getElementById(candidate)){
      candidate='legal-'+base+'-'+index;
      index+=1;
    }
    used[candidate]=true;
    return candidate;
  }

  function enhancePolicy(root){
    var body=root.querySelector('.shopify-policy__body .rte');
    if(!body)return;

    var used={};
    var synthetic=[];
    Array.prototype.forEach.call(body.children,function(node){
      if(node.tagName!=='P')return;
      var strong=node.firstElementChild;
      if(!strong||strong.tagName!=='STRONG')return;
      var full=node.textContent.trim();
      var label=strong.textContent.trim();
      if(!label||label.length>110)return;
      var isStandalone=full===label;
      var isNumbered=/^section\s+\d+\b/i.test(label);
      var isOverview=/^overview$/i.test(label);
      if(!isStandalone||(!isNumbered&&!isOverview))return;
      node.setAttribute('role','heading');
      node.setAttribute('aria-level','2');
      node.setAttribute('data-nn-legal-heading','');
      synthetic.push(node);
    });

    var headings=Array.prototype.slice.call(body.querySelectorAll('h2,h3,[data-nn-legal-heading]'));
    headings.forEach(function(heading){
      if(!heading.id)heading.id=uniqueId(slugify(heading.textContent),used);
    });

    var toc=root.querySelector('[data-nn-legal-toc]');
    var list=root.querySelector('[data-nn-legal-toc-list]');
    if(!toc||!list)return;
    if(headings.length<3){
      toc.hidden=true;
      return;
    }

    var fragment=document.createDocumentFragment();
    headings.forEach(function(heading){
      var item=document.createElement('li');
      var link=document.createElement('a');
      link.href='#'+heading.id;
      link.textContent=heading.textContent.trim();
      link.dataset.level=heading.tagName==='H3'?'3':'2';
      item.appendChild(link);
      fragment.appendChild(item);
    });
    list.replaceChildren(fragment);

    if('IntersectionObserver' in window){
      var links=Array.prototype.slice.call(list.querySelectorAll('a'));
      var byId={};
      links.forEach(function(link){byId[link.hash.slice(1)]=link;});
      var active=null;
      var observer=new IntersectionObserver(function(entries){
        var visible=entries.filter(function(entry){return entry.isIntersecting;}).sort(function(a,b){return a.boundingClientRect.top-b.boundingClientRect.top;});
        if(!visible.length)return;
        var next=byId[visible[0].target.id];
        if(active)active.classList.remove('is-active');
        if(next){next.classList.add('is-active');active=next;}
      },{rootMargin:'-20% 0px -68% 0px',threshold:0});
      headings.forEach(function(heading){observer.observe(heading);});
    }
  }

  function init(root){
    if(root.dataset.nnLegalReady==='true')return;
    root.dataset.nnLegalReady='true';
    enhancePolicy(root);

    var status=root.querySelector('[data-nn-legal-status]');
    var copy=root.querySelector('[data-nn-legal-copy]');
    var print=root.querySelector('[data-nn-legal-print]');

    if(copy){
      copy.addEventListener('click',function(){
        var value=window.location.href.split('#')[0];
        var done=function(){
          if(status)status.textContent='Document link copied.';
          var label=copy.querySelector('span');
          var prior=label?label.textContent:'';
          if(label)label.textContent='Link copied';
          window.setTimeout(function(){if(label)label.textContent=prior;},1400);
        };
        if(navigator.clipboard&&window.isSecureContext){
          navigator.clipboard.writeText(value).then(done).catch(function(){if(status)status.textContent='Copy was not available. Use the address bar to copy this page.';});
        }else{
          if(status)status.textContent='Use the address bar to copy this page.';
        }
      });
    }
    if(print)print.addEventListener('click',function(){window.print();});
  }

  function boot(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-nn-legal]'),init);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();
